import { useAuth } from './useAuth'

export const PLANOS_CONFIG = {
  // Estado interno para usuários sem plano ativo (trial expirado, sem assinatura)
  free: {
    nome: 'Sem plano',
    cor: '#888888',
    preco: 0,
    stripePriceMonthly: null,
    stripePriceAnnual: null,
    limiteShows: 0,
    podeBuscarWeb: false,
    podeImportarPDF: false,
    podeImportarFoto: false,
    podeImportarAudio: false,
    temClassic: false,
  },
  solo: {
    nome: 'Solo',
    cor: '#00CFFF',
    preco: 9.90,
    stripePriceMonthly: process.env.REACT_APP_STRIPE_PRICE_SOLO_MONTHLY,
    stripePriceAnnual:  process.env.REACT_APP_STRIPE_PRICE_SOLO_ANNUAL,
    limiteShows: 1,
    podeBuscarWeb: true,
    podeImportarPDF: false,
    podeImportarFoto: false,
    podeImportarAudio: false,
    temClassic: false,
  },
  musico: {
    nome: 'Músico',
    cor: '#FF8C00',
    preco: 24.90,
    stripePriceMonthly: process.env.REACT_APP_STRIPE_PRICE_MUSICO_MONTHLY,
    stripePriceAnnual:  process.env.REACT_APP_STRIPE_PRICE_MUSICO_ANNUAL,
    limiteShows: 4,
    podeBuscarWeb: true,
    podeImportarPDF: true,
    podeImportarFoto: true,
    podeImportarAudio: false,
    temClassic: false,
  },
  maestro: {
    nome: 'Maestro',
    cor: '#a855f7',
    preco: 39.90,
    stripePriceMonthly: process.env.REACT_APP_STRIPE_PRICE_MAESTRO_MONTHLY,
    stripePriceAnnual:  process.env.REACT_APP_STRIPE_PRICE_MAESTRO_ANNUAL,
    limiteShows: Infinity,
    podeBuscarWeb: true,
    podeImportarPDF: true,
    podeImportarFoto: true,
    podeImportarAudio: true,
    temClassic: false,
  },
}

// MODO TESTE: REACT_APP_UNLOCK_ALL=true libera todos os recursos sem Stripe/Classic
// Remover esta flag antes de ir para produção final
const UNLOCK_ALL = process.env.REACT_APP_UNLOCK_ALL === 'true'

export function usePlano() {
  const { profile } = useAuth()

  // Modo teste: simula plano maestro completo para qualquer usuário logado
  if (UNLOCK_ALL) {
    const config = PLANOS_CONFIG.maestro
    return {
      plano: 'maestro',
      planoRaw: 'maestro',
      planoExpirado: false,
      planoExpiraEm: null,
      config,
      isPago: true,
      temPlano: true,
      podeShow: true,
      podeBuscarWeb: true,
      podeImportar: true,
      podeImportarPDF: true,
      podeImportarFoto: true,
      podeImportarAudio: true,
      temClassic: true,
      podeIniciarShow: true,
      showsRestantes: null,
      showsUsadosMes: 0,
      limiteShows: Infinity,
    }
  }

  const planoRaw = profile?.plano || 'free'

  const agora = new Date()
  const expiraEm = profile?.plano_expira_em ? new Date(profile.plano_expira_em) : null
  const planoExpirado = planoRaw !== 'free' && expiraEm !== null && agora > expiraEm
  const plano = planoExpirado ? 'free' : planoRaw

  const config = PLANOS_CONFIG[plano] || PLANOS_CONFIG.free

  const showsUsadosMes = profile?.shows_usados_mes ?? 0
  const limiteShows    = config.limiteShows
  const ilimitado      = limiteShows === Infinity

  const podeIniciarShow = plano !== 'free' && (ilimitado || showsUsadosMes < limiteShows)
  const showsRestantes  = ilimitado ? null : Math.max(0, limiteShows - showsUsadosMes)

  return {
    plano,
    planoRaw,
    planoExpirado,
    planoExpiraEm: expiraEm,
    config,
    isPago:             plano !== 'free',
    temPlano:           plano !== 'free',
    podeShow:           config.limiteShows > 0,
    podeBuscarWeb:      config.podeBuscarWeb,
    podeImportar:       config.podeImportarAudio,
    podeImportarPDF:    config.podeImportarPDF,
    podeImportarFoto:   config.podeImportarFoto,
    podeImportarAudio:  config.podeImportarAudio,
    temClassic:         config.temClassic,
    podeIniciarShow,
    showsRestantes,
    showsUsadosMes,
    limiteShows,
  }
}
